<template>
	<div>
		<h1 v-translate>Sidan hittades inte</h1>
	</div>
</template>

<script lang="ts" setup>
</script>
